import TextField from "@mui/material/TextField";
import Pass from "../Logo/PasswordGif.gif";
import styled from "styled-components";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import "@fontsource/roboto/300.css";
import axios from "axios";
import { RolesContext } from "../context/User";
import PopupWithSelect from "./Popup";
import Alert from "@mui/material/Alert";
import { Box } from "@mui/material";

const Gif = styled.img`
  height: 150px;
  width: 202px;
`;

function Otp({ userData, source, user, urlEncode, authMethod = "SMS" }) {
  const navigate = useNavigate();
  const [errorMessage, seterrorMessage] = useState("");
  const [error, setError] = useState(false);
  const textFieldRef = useRef();
  const textFieldRefSmall = useRef();
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [text, setText] = useState(false);

  const maskEmail = (email) => {
    if (!email) return "";
    
    const [localPart, domain] = email.split('@');
    
    // Show first 4 characters, mask the rest before @
    const visibleChars = 4;
    const visibleStart = localPart.slice(0, visibleChars);
    const maskedPart = 'X'.repeat(Math.max(0, localPart.length - visibleChars));
    
    return `${visibleStart}${maskedPart}@${domain}`;
  };

  const sendForm = (event) => {
    if (event.key == "Enter") {
      handleButtonClick();
    }
  };

  useEffect(() => {
    textFieldRef.current.focus();
  }, []);

  const handleButtonSendAgain = async () => {
    textFieldRef.current.value = "";
    textFieldRefSmall.current.value = "";
    setError(false);
    seterrorMessage("");
    try {
      const response = await axios.get(`/signIn/${urlEncode}`, {
        withCredentials: true,
      });
      if (response.data.status == 200) {
        setText(true);
        setTimeout(() => {
          setText(false);
        }, 10000);
      }
    } catch (error) {
      if (error.response.status == 403) {
        navigate("/");
      }
    }
  };

  const handleButtonClick = () => {
    async function fetchData() {
      try {
        const response = await axios.post("/authByOtp", {
          pass: textFieldRef.current.value
            ? textFieldRef.current.value
            : textFieldRefSmall.current.value,
          identify: userData.cust_id,
          contact: userData.Identify,
          authMethod: authMethod,
          program: "openInvoice",
          roles: user.roles,
          customers: user.customers,
          src: source,
          name: user.name,
          siteLabel: user.siteLabel || null,
        }, { withCredentials: true });
        let response_data = response.data;
        if (response_data.valid || response.status == 200) {
          dispatchroles({
            type: "USER",
            payload: {
              value: user,
            },
          });
          // ------------------check this - when user has only one client----------------------------------
          if (user.customers.length == 1) {

            try {
              const response = await axios.get(
                `/adminPermissions/change_cust_id/${
                  user.customers[0].CUSTNAME
                }~${user.customers[0].CUSTDES.replace("/", "-")}`,
                // `/adminPermissions/change_cust_id/${selectedOption.CUSTNAME}`,
                {
                  withCredentials: true,
                }
              );
            } catch (error) {
              if (error.response.status == 403) {
                navigate("/");
              }
            }
            dispatchroles({
              type: "USER_UPDATE",
              payload: {
                value: user.customers[0],
              },
            });
          }
          // ---------------------------------------------------
          navigate(`/${source}`);
        }
      } catch (error) {
        if (error.response.status == 400) {
          seterrorMessage(error.response.data);
          setError(true);
        } else if (error.response.status == 402) {
          seterrorMessage(error.response.data);
          setError(true);
        } else if (error.response.status == 403) {
          navigate("/");
        } else {
          seterrorMessage(error.response.data);
          setError(true);
        }
      }
    }
    fetchData();
  };

  return (
    <Container fixed>
      <Box
        sx={{
          display: { xs: "block", md: "none" },
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          sx={{
            // marginTop: "7rem",
            marginBottom: "1rem",
            textAlign: "center",
          }}
        >
          {/* <Grid item>
            <Gif src={Pass} alt="Lock-picture" />
          </Grid> */}
        </Grid>
        <Typography
          variant="subtitle1"
          component="h2"
          sx={{ textAlign: "center" }}
        >
          {authMethod === "EMAIL" 
            ? `אנא הקלד את הקוד לאימות שנשלח אליך למייל ${userData ? maskEmail(userData.Identify) : ""}` 
            : `אנא הקלד את הקוד לאימות שנשלח אליך למספר 05X-XXX${userData ? userData.Identify.slice(-4) : ""}`
          }
        </Typography>
        <br />
        <Stack
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
          spacing={2}
          marginBottom="1rem"
        >
          <TextField
            focused
            tabIndex={0}
            id="password_1"
            type="text"
            inputRef={textFieldRefSmall}
            helperText={errorMessage}
            error={error}
            sx={{
              width: "150px",
              "& input": {
                fontSize: "15px",
                letterSpacing: "15px",
                textAlign: "center",
              },
            }}
            inputProps={{
              maxLength: 4,
              alt: "InputPassword",
              onKeyDown: (event) => {
                if (event.key === "Enter") {
                  handleButtonClick();
                }
              },
            }}
          />
        </Stack>
        <Grid container alignItems="center" justifyContent="center">
          <Grid item>
            <Button
              variant="contained"
              size="small"
              onClick={handleButtonClick}
              onKeyDown={(event) => sendForm(event)}
              startIcon={<SendIcon />}
            >
              אימות
            </Button>
            <Button
              variant="text"
              size="small"
              sx={{ marginLeft: "0.5rem" }}
              onClick={handleButtonSendAgain}
              onKeyDown={(event) => sendForm(event)}
            >
              שלח קוד מחדש
            </Button>
          </Grid>
        </Grid>
        <br />
        <Grid container alignItems="center" justifyContent="center">
          {text ? <Alert severity="success">קוד נוסף נשלח בהצלחה</Alert> : null}
        </Grid>
      </Box>
      <Box
        sx={{
          display: { xs: "none", md: "block" },
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          sx={{
            // marginTop: "7rem",
            marginBottom: "1rem",
            textAlign: "center",
          }}
        >
          {/* <Grid item>
            <Gif src={Pass} alt="Lock-picture" />
          </Grid> */}
        </Grid>
        <Typography variant="h6" component="h2" sx={{ textAlign: "center" }}>
          {authMethod === "EMAIL" 
            ? `אנא הקלד את הקוד לאימות שנשלח אליך למייל ${userData ? maskEmail(userData.Identify) : ""}` 
            : `אנא הקלד את הקוד לאימות שנשלח אליך למספר 05X-XXX${userData ? userData.Identify.slice(-4) : ""}`
          }
        </Typography>
        <br />
        <Stack
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
          spacing={2}
          marginBottom="3rem"
        >
          <TextField
            focused
            tabIndex={0}
            id="password_12"
            type="text"
            inputRef={textFieldRef}
            helperText={errorMessage}
            error={error}
            sx={{
              width: "200px",
              "& input": {
                fontSize: "20px",
                letterSpacing: "20px",
                textAlign: "center",
              },
            }}
            inputProps={{
              maxLength: 4,
              alt: "InputPassword",
              onKeyDown: (event) => {
                if (event.key === "Enter") {
                  handleButtonClick();
                }
              },
            }}
          />
        </Stack>
        <Grid container alignItems="center" justifyContent="center">
          <Grid item>
            <Button
              variant="contained"
              size="large"
              onClick={handleButtonClick}
              onKeyDown={(event) => sendForm(event)}
              startIcon={<SendIcon />}
            >
              אימות
            </Button>
            <Button
              variant="text"
              size="large"
              onClick={handleButtonSendAgain}
              onKeyDown={(event) => sendForm(event)}
            >
              שלח קוד מחדש
            </Button>
          </Grid>
        </Grid>
        <br />
        <Grid container alignItems="center" justifyContent="center">
          {text ? <Alert severity="success">קוד נוסף נשלח בהצלחה</Alert> : null}
        </Grid>
      </Box>
    </Container>
  );
}

export default Otp;
